import axios from "axios";
import Qs from "qs";
import store from "../store";
import { Loading } from 'element-ui';
let loading = false

const instance = axios.create({
  baseURL: "/"
});
function openLoading (loadingDom) {
  loading = Loading.service({
    lock: true,
    text: '请稍后',
    background: 'rgba(255, 255, 255, 0.7)',
    target: loadingDom || 'body'
  })
}
function closeLoading () {
  loading && loading.close()
}

//请求拦截器
instance.interceptors.request.use((config) => {
  if (config.method === "post") {
    config.data = Qs.stringify(config.data);
  }
  config.headers['Authorization'] = sessionStorage.getItem('token')
  //显示加载中效果
  openLoading()
  store.state.loading = true;
  return config;
}), (err) => {
  return Promise.reject(err);
};

//响应拦截器
instance.interceptors.response.use(data => {
  // 响应成功关闭loading
  store.state.loading = false;
  setTimeout(() => {
    closeLoading()
  }, 0);
  return data
}, error => {
  closeLoading()
  return Promise.reject(error)
})

export default instance;
